import PropTypes from 'prop-types';

import FormRow from './FormRow';
import styles from './TextAreaInput.module.scss';

function TextAreaInput({
  rowModifier,
  placeholder,
  hideLabel,
  required,
  onChange,
  label,
  value,
  name,
  rows = 3,
  id,
  ...attributes
}) {
  return (
    <FormRow
      modifier={rowModifier}
      hideLabel={hideLabel}
      required={required}
      label={label}
      id={id}
    >
      <textarea
        placeholder={placeholder}
        className={styles.input}
        onChange={onChange}
        required={required}
        value={value}
        name={name}
        rows={rows}
        id={id}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...attributes}
      />
    </FormRow>
  );
}

TextAreaInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  rowModifier: PropTypes.string,
  hideLabel: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.number,
};

export default TextAreaInput;
